<!--
 The block is centred by its own auto margins rather than by `justify-center`, so that a panel too
 short for it scrolls from the top instead of hiding the last example past the bottom edge.
-->
<div
  #scroller
  class="w-full h-full p-4 flex flex-col overflow-y-auto mib-scrollbar not-height-medium:p-3 not-height-medium:pt-0"
  [class.max-w-md]="!compactWelcome()"
  [class.max-w-2xl]="compactWelcome()">
  <div
    #content
    class="m-auto w-full flex flex-col items-center not-expanded:gap-6"
    [class.gap-12]="!compactWelcome()"
    [class.gap-6]="compactWelcome()">
    <div class="flex flex-col gap-2 text-mib-branding-50 text-center">
      <h3 class="text-2xl">Hello!</h3>
      <p class="text-sm">{{ assistantIntro() }}</p>
      <p class="text-sm" [innerHTML]="assistantSubtext()"></p>
    </div>

    <mai-prompt-box class="w-full" [displayPlusButton]="isCompactHeight()"></mai-prompt-box>

    @if (promptExamples().length > 0) {
      <div
        #examples
        class="w-full grid gap-3 not-height-medium:hidden not-expanded:gap-2"
        [class.grid-cols-2]="twoPerRow()">
        @for (example of promptExamples(); track example.prompt) {
          <button
            mibButton
            type="button"
            theme="ai"
            class="w-full justify-start"
            (click)="useExample(example)">
            <div class="py-2 flex gap-2 items-center">
              <mai-prompt-example-icon [type]="example.icon"></mai-prompt-example-icon>
              <span class="text-left">
                {{ example.title }}
              </span>
            </div>
          </button>
        }
      </div>
    }
  </div>
</div>
